
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 320 448","fill":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M320 349.75c0 36.5-24 66.25-53.25 66.25H53.25C24 416 0 386.25 0 349.75 0 284 16.25 208 81.75 208 102 227.75 129.5 240 160 240s58-12.25 78.25-32c65.5 0 81.75 76 81.75 141.75zM256 128c0 53-43 96-96 96s-96-43-96-96 43-96 96-96 96 43 96 96z"}})])
          )
        }
      }
    